import { FormattedMessage } from 'react-intl';
import { Space } from 'antd';

import { getFormattedDate } from '@/utils/moment';

// import { DeleteAction } from "@/components/table/actions";
// import { PERMISSION_DELETE, PERMISSION_OBJ_WAYBILL_WEIGHING_ANALYSIS } from "@/constants/permissions";
// import { waybillWeighingAnalysisStore } from "@/stores";
// import { showError } from "@/utils/common";
// import { withPermissions } from "@/hocs/permission";

// const PermissionedDeleteAction = withPermissions([[PERMISSION_OBJ_WAYBILL_WEIGHING_ANALYSIS, PERMISSION_DELETE]])(DeleteAction);

const Actions = ({ waybillId, analysisId }: { waybillId: number; analysisId: number }) => {
  return <Space>{/* TODO: enable delete action when API endpoint is ready */}</Space>;
};

export const getColumns = (waybillId: number) => {
  return [
    {
      title: 'id',
      dataIndex: 'id',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.weighing-code" />,
      dataIndex: 'weighingCode',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.cooperative" />,
      dataIndex: ['cooperative', 'name'],
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.cooperative-code" />,
      dataIndex: ['cooperative', 'code'],
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.exporter" />,
      dataIndex: ['exporter', 'name'],
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.origin-department" />,
      dataIndex: 'originDepartment',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.bags-count" />,
      dataIndex: 'bagsCount',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.accepted-weight" />,
      dataIndex: 'acceptedWeight',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.nat-grade" />,
      dataIndex: 'natGrade',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.fcc-grade" />,
      dataIndex: 'fccGrade',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.ccc-export-datetime" />,
      dataIndex: 'cccExportDatetime',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.weighing-date" />,
      dataIndex: 'weighingDate',
      render: getFormattedDate,
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.analysis-date" />,
      dataIndex: 'analysisDate',
      render: getFormattedDate,
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.bulletin-number" />,
      dataIndex: 'bulletinNumber',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.controller" />,
      dataIndex: ['controller', 'name'],
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.humidity" />,
      dataIndex: 'humidity',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.foreign-materials" />,
      dataIndex: 'foreignMaterials',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.graininess" />,
      dataIndex: 'graininess',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.slate-beans" />,
      dataIndex: 'slateBeans',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.moldy-beans" />,
      dataIndex: 'moldyBeans',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.broken-beans" />,
      dataIndex: 'brokenBeans',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.waste" />,
      dataIndex: 'waste',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.crabots" />,
      dataIndex: 'crabots',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.defective-beans" />,
      dataIndex: 'defectiveBeans',
      sorter: true,
    },
    {
      title: <FormattedMessage id="waybill.weighing-analysis.violet-beans" />,
      dataIndex: 'violetBeans',
      sorter: true,
    },
    {
      title: '',
      render: (_, record: any) => <Actions waybillId={waybillId} analysisId={record.id} />,
      className: 'actions',
    },
  ];
};
